
import { Component, Vue, Prop } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  handleOpen(item: string) {
    switch (item) {
      case 'bookBoy':
        window.open('https://mp.weixin.qq.com/s/Hg-gZWpQh42t41DEORRfTg')
        return
      case 'teachAssistant':
        window.open('https://mp.weixin.qq.com/s/tU5c8xPM-5lG0loXRMIYeg')
        return
      case 'itHelp':
        window.open('https://mp.weixin.qq.com/s/aC_qW25o6CxgZg3y1CsPWg')
        return
      case 'wenfang':
        window.open('https://mp.weixin.qq.com/s/PISSv6v306oVXYvpQu4TTA')
        return
      default:
        return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
